@use '../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../styles/Constants.scss' as Constants;

.dropdown {
	border: 1px solid Colors.$col-greyMid;
	border-radius: Constants.$val-borderRadius;
}